module.exports = axios;


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = 1054
// module chunks = 75